import { createFileRoute, Outlet } from "@tanstack/react-router";
import React from "react";
import PortalLayout from "@/components/portal/PortalLayout";

const PortalRoute = () => <PortalLayout />;

export const Route = createFileRoute("/portal")({
  component: PortalRoute,
});
